import { render, staticRenderFns } from "./OsvTicketing.vue?vue&type=template&id=252b2d2e&scoped=true&"
import script from "./OsvTicketing.vue?vue&type=script&lang=js&"
export * from "./OsvTicketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b2d2e",
  null
  
)

export default component.exports